module.exports = __webpack_public_path__ + "img/64_bits_addressable.38da68a4.png";